// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a0c90837","513":"23467077","703":"024ed7dc","787":"0ed693eb"}[chunkId] + ".chunk.js";
};